import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { graphql, useStaticQuery } from 'gatsby';

import '../../styles/homepage.css';
import '../../styles/generic.css';

import { _ } from '../../utils/l10n';
import { RecursiveNonNullable } from '../../types';

export const Partners = () => {
  const data = useStaticQuery<RecursiveNonNullable<Queries.HomePagePartnersQuery>>(graphql`
    query HomePagePartners {
      file(
        sourceInstanceName: { eq: "content" }
        relativeDirectory: { eq: "" }
        name: { eq: "index" }
      ) {
        childMdx {
          frontmatter {
            partners {
              sub_title
              list {
                name
                url
                logo {
                  childImageSharp {
                    gatsbyImageData(placeholder: NONE)
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  const {
    file: { childMdx: { frontmatter: { partners: { sub_title, list: partners } } } }
  } = data;

  return (
    <section className='partners-container'>
      <span className='title-4'>{sub_title}</span>
      <ul className='partners-list'>
        {partners.map(({ name, url, logo }) => {
          const image = getImage(logo);

          if (image) {
            return (
              <li key={name} className='partner-item'>
                <a href={url} target='_blank'>
                  <GatsbyImage image={image} alt={name} objectPosition='left' objectFit='contain' />
                </a>
              </li>
            );
          }
        })}
      </ul>
    </section>
  );
};
